<style lang="scss">
@media only screen and (max-width: 321px) {
  .toast {
    max-width: 304px !important;
  }
}
@media only screen and (min-width: 333px) and (max-width: 361px) {
  .toast {
    max-width: 345px !important;
  }
}
@media only screen and (max-width: 700px) {
  .notification {
    margin-left: auto !important;
  }
  .icon-menu {
    margin-left: 0 !important;
  }
  .mr-4.header-mobile {
    margin-right: 0.5rem !important;
  }
  .list-notification {
    width: 100%;
    height: 100%;
    left: 0;
    min-width: 0 !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .toast {
    width: 100%;
  }
  .list-notification {
    left: 30%;
  }
  .notification {
    margin-left: auto;
  }
  .mr-4.header-mobile {
    margin-right: 0.5rem !important;
  }
}
</style>
<style lang="scss" scoped>
.bg-white {
  background-color: #fff;
}

.notification {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;

  .notification-icon {
    position: relative;
    cursor: pointer;

    .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size) {
      width: 30px;
      height: 30px;
    }

    .count-notification {
      position: absolute;
      background-color: red;
      display: inline;
      padding: 0px 6.5px;
      border-radius: 15px;
      font-weight: 600;
      color: #ffffff;
      top: -35%;
      right: -15%;
    }
  }

  .list-notification {
    position: absolute;
    z-index: 1000;
    top: 54%;
    right: 14%;
    background: #f3f3f3;
    max-height: 500px;
    overflow-y: auto;
    max-width: 500px;
    min-height: 500px;
    min-width: 350px;

    .none-notification {
      text-align: center;
      font-weight: bold;
      margin-top: 100px;
      font-size: 20px;
    }

    .notification-header {
      text-align: center;
      font-weight: bold;
      background-color: #3c4b64;
      color: aliceblue;
      padding: 10px 0;
      font-size: 1.3rem;
    }

    .notification-detail {
      cursor: pointer;
      border-bottom: 1px solid #bdbdbd;
      border-left: solid 1px #00000000;
      padding: 15px 10px;
      text-align: center;
      display: flex;
      .notification-detail-icon {
        width: 15%;
      }
      .notification-detail-info {
        width: 85%;
        text-align: left;
        padding-left: 15px;
        a b {
          color: #3c4b64;
        }
        a {
          text-decoration: none;
          color: #636f83;
        }
      }
      .notification-detail-time {
        width: 20%;
      }
    }

    .notification-readed {
      background-color: #d3ebef;
    }

    .notification-detail:hover {
      background-color: #fcfade;
    }
  }

  #style-1::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  #style-1::-webkit-scrollbar {
    width: 12px;
    background-color: #f5f5f5;
  }

  #style-1::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #555;
  }
}
</style>
<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="icon-menu d-lg-none"
      @click="$store.dispatch('layout/toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="icon-menu d-md-down-none"
      @click="$store.dispatch('layout/toggleSidebarDesktop')"
    />
    <CHeaderNav class="d-md-down-none mr-auto"> </CHeaderNav>

    <div class="notification">
      <div
        @click="showNotification"
        class="notification-icon"
        id="notification-icon"
      >
        <CIcon name="cil-bell" />
        <span
          class="count-notification"
          v-if="listNotification.countNotificationUnread > 0"
          >{{ listNotification.countNotificationUnread }}
        </span>
      </div>
      <div class="list-notification" id="style-1" v-if="status">
        <div class="notification-header">
          {{ $t("notification.label_header_notification") }}
        </div>
        <div
          class="none-notification"
          v-if="listNotification.listNotifications.length === 0"
        >
          {{ $t("notification.label_none_notification") }}
        </div>
        <div
          class="notification-detail"
          v-else
          v-for="notification in listNotification.listNotifications"
          :key="notification.id"
          v-bind:class="
            notification.is_readed === 0 ? 'notification-readed' : ''
          "
          v-on:click="updateStatus(notification)"
        >
          <div class="notification-detail-icon">
            <img
              v-if="notification.image_url"
              class="image-avartar"
              :src="notification.image_url"
              width="40"
              height="40"
            />
            <img
              v-else
              class="image-avartar"
              src="@/assets/avatar_default.png"
              width="40"
              height="40"
            />
          </div>
          <div class="notification-detail-info">
            <template v-if="notification.request_type !== 'APPROVED'">
              <b>{{ notification.created_by }}</b>
              {{
                $t(
                  "notification." +
                    notification.type +
                    ".message_send_notification"
                )
              }}
              <span v-if="notification.type === 'FORGOT_CHECKIN_CHECKOUT'">
                {{ formatDateOverTime(notification.created_at) }}
              </span>
            </template>
            <template v-if="notification.request_type === 'APPROVED'">
              {{
                $t(
                  "notification." +
                    notification.type +
                    ".message_approval_notification"
                )
              }}
            </template>
          </div>
        </div>
      </div>
    </div>

    <CHeaderNav class="mr-4 header-mobile">
      <select
        v-model="$i18n.locale"
        class="form-control"
        @change="changeLanguage($event)"
      >
        <option
          v-for="(lang, i) in $store.getters['lang/locales']"
          :key="`Lang${i}`"
          :value="lang"
        >
          {{ $t(`locale.${lang}`) }}
        </option>
      </select>
      <HeaderDropdownAccount />
    </CHeaderNav>
    <CSubheader class="px-3">
      <Breadcrumb />
    </CSubheader>
    <NotificationDrawer :visible="isShownNotificationDrawer" :notification="drawerNotification" @onClose="handleDrawerClose"/>
  </CHeader>
</template>

<script>
import HeaderDropdownAccount from "./HeaderDropdownAccount";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Breadcrumb from "@/components/commons/Breadcrumb";
import moment from "moment";
import NotificationDrawer from "./NotificationDrawer.vue";

export default {
  name: "Header",
  components: {
    HeaderDropdownAccount,
    Breadcrumb,
    NotificationDrawer
  },
  data() {
    return {
      status: false,
      isShownNotificationDrawer: false,
      drawerNotification: null,
    };
  },
  computed: {
    ...mapGetters({
      listNotification: "commons/notifications",
      flag: "commons/flag"
    })
  },
  methods: {
    ...mapActions("lang", ["setLocale"]),
    ...mapActions("commons", ["getNotification"]),
    ...mapMutations("commons", ["setNotificationFlag"]),

    showNotification() {
      this.status = !this.status;
    },

    changeLanguage(event) {
      let locale = event.target.value;
      this.setLocale({ locale });
    },

    handleDrawerClose() {
      this.isShownNotificationDrawer = false;
      this.drawerNotification = null;
    },

    async updateStatus(notification) {
      let {id, url, type} = notification;
      const drawerShowTypes = [
        "ADDITIONAL_TIMESHEET",
        "OVERTIME_REQUEST",
        "REMOTE_WORKING_REQUEST"
      ];
      if (drawerShowTypes.includes(type)) {
        this.drawerNotification = notification;
        this.isShownNotificationDrawer = true;
      } else if (id != this.$route.query.notification) {
        this.setNotificationFlag(true);
        this.$router.push({ path: `${url}`, query: { notification: id } });
      }
      await this.$store
        .dispatch("commons/updateStatusNotification", id)
        .then(() => {
          this.getNotification();
        })
        .catch(() => {});
    },

    formatDateOverTime(value) {
      if (value) {
        var dt = new Date(value);
        dt.setDate(dt.getDate() - 1);
        return moment(String(dt)).format("DD/MM/YYYY");
      }
    }
  },
  created() {
    this.getNotification();
  },
  mounted() {
    // prevent click outside event with popupItem.
    this.popupItem = this.$el;
    let vue = this;
    window.addEventListener("click", function(event) {
      if (
        vue.status === true &&
        event.target.parentElement.id !== "notification-icon"
      ) {
        vue.status = false;
      }
    });
  }
};
</script>
